// pages/LandingPage.js
import { useEffect } from 'react';
import { addDoc, collection, serverTimestamp, setDoc, doc, increment, Timestamp } from 'firebase/firestore';
import { db } from '../firebase';
import Header from '../components/landing/Header';
import HeroSection from '../components/landing/HeroSection';
import PartnersCarousel from '../components/landing/PartnersCarousel';
import FeaturesSection from '../components/landing/FeaturesSection';
import ClientsCarousel from '../components/landing/ClientsCarousel';
import ProcessSection from '../components/landing/ProcessSection';
import TestimonialsSection from '../components/landing/TestimonialsSection';

import FAQSection from '../components/landing/FAQSection';
import CTASection from '../components/landing/CTASection';
import Footer from '../components/landing/Footer';
import BackToTop from '../components/landing/BackToTop';
import PricingCard from '../components/landing/Planos';
//import ParceirosEcommerce from '../components/landing/Parceiros';

const LandingPage = () => {
  useEffect(() => {
    // Configura smooth scroll para links âncora
    const setupSmoothScroll = () => {
      document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
          e.preventDefault();
          const targetId = this.getAttribute('href');
          if (targetId === '#') return;

          const targetElement = document.querySelector(targetId);
          if (targetElement) {
            window.scrollTo({
              top: targetElement.offsetTop - 80,
              behavior: 'smooth'
            });
          }
        });
      });
    };

    setupSmoothScroll();

    // Inicializa Swiper se existir
    if (typeof window !== 'undefined' && window.Swiper) {
      // A variável swiper não é usada, então não precisamos atribuí-la a uma variável
      new window.Swiper('.swiper.clientes-swiper', {
        loop: true,
        slidesPerView: 'auto',
        centeredSlides: true,
        spaceBetween: 30,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        breakpoints: {
          640: {
            slidesPerView: 3,
          },
          1024: {
            slidesPerView: 5,
          }
        }
      });
    }

    const recordPageview = async () => {
      try {
        // Registra pageview em tempo real (para gráfico de acessos por minuto)
        await addDoc(collection(db, 'realtimeMetrics'), {
          metricType: 'pageview',
          timestamp: serverTimestamp(),
          path: window.location.pathname
        });

        const now = new Date();
        const startOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        const dayKey = `${startOfDay.getFullYear()}${String(startOfDay.getMonth()+1).padStart(2,'0')}${String(startOfDay.getDate()).padStart(2,'0')}`;

        // 1. Contabiliza Impressão (Sempre que carrega a página)
        await setDoc(doc(db, 'dailyMetrics', `${dayKey}_impressions`), {
          metricType: 'impressions',
          date: Timestamp.fromDate(startOfDay),
          value: increment(1)
        }, { merge: true });

        // 2. Contabiliza Acesso (Único por sessão)
        const sessionKey = `visited_${dayKey}`;
        if (!sessionStorage.getItem(sessionKey)) {
          // Registra visita única em tempo real
          await addDoc(collection(db, 'realtimeMetrics'), {
            metricType: 'visit',
            timestamp: serverTimestamp(),
            path: window.location.pathname
          });

          await setDoc(doc(db, 'dailyMetrics', `${dayKey}_visits`), {
            metricType: 'visits',
            date: Timestamp.fromDate(startOfDay),
            value: increment(1)
          }, { merge: true });
          sessionStorage.setItem(sessionKey, 'true');
        }

      } catch (error) {
        console.error("Erro ao registrar métricas:", error);
      }
    };
    recordPageview();

  }, []);

  return (
    <div className="landing-page">
      <Header />
      <main>
        <HeroSection />
        <PartnersCarousel />
        <FeaturesSection />
        <ClientsCarousel />
        <PricingCard  />
        <ProcessSection />
        <TestimonialsSection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
};

export default LandingPage;